import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, watchEffect } from "@nuxtjs/composition-api";

import { useCartItem } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductCheckout',
  props: {
  retailerProductVariantId: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isBuyNowLoading: {
    type: Boolean,
    default: false,
  },
  isAddToCartLoading: {
    type: Boolean,
    default: false,
  },
  isUpdateCartLoading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["add-to-cart", "update-cart-quantity"],
  setup(__props, { emit }: { emit: ({
  (event: "add-to-cart"): Promise<void>;
  (event: "update-cart-quantity", quantity: number): Promise<void>;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { retailerProductVariantId, disabled, isBuyNowLoading, isAddToCartLoading, isUpdateCartLoading } = toRefs(props);
const quantity = ref(0);

const { cartItem } = useCartItem(retailerProductVariantId);

watchEffect(() => {
  if (cartItem.value) {
    quantity.value = cartItem.value.quantity;
  }
});

const isSubtractButtonDisabled = computed(() => quantity.value === 0);

const onAddToCart = () => emit("add-to-cart");
const onConfirmUpdateCartQuantity = () => {
  emit("update-cart-quantity", quantity.value);
};
const onAddQuantity = () => {
  quantity.value += 1;
};
const onSubtractQuantity = () => {
  quantity.value -= 1;
};

return { __sfc: true,props, emit, retailerProductVariantId, disabled, isBuyNowLoading, isAddToCartLoading, isUpdateCartLoading, quantity, cartItem, isSubtractButtonDisabled, onAddToCart, onConfirmUpdateCartQuantity, onAddQuantity, onSubtractQuantity }
}

})